import { useInfiniteQuery } from '@tanstack/react-query'
import {
  fetchActionsPage,
  getNextActionsPageParam,
  type UseActionsParams
} from '~/domains/actions/queries/actions'

export type UseTasksParams = Omit<
  UseActionsParams,
  'expectsCompletion' | 'order' | 'orderDirection' | 'isCancelled'
>

/** Open tasks come soonest first; treated ones most recently treated first. */
export const toTaskActionsParams = (
  params: UseTasksParams
): UseActionsParams => ({
  ...params,
  expectsCompletion: true,
  isCancelled: false,
  order: params.treated ? 'eventDate' : 'scheduledDate',
  orderDirection: params.treated ? 'desc' : 'asc'
})

export const useTasks = ({ enabled, ...params }: UseTasksParams = {}) =>
  useInfiniteQuery({
    queryKey: ['tasks', params],
    queryFn: ({ pageParam = 1 }) =>
      fetchActionsPage(toTaskActionsParams(params), pageParam),
    getNextPageParam: getNextActionsPageParam,
    initialPageParam: 1,
    staleTime: 60_000,
    enabled
  })
